// lbl.mission
export const mission = {
    you_have: 'คุณมี',
    point_unit: 'แพลงก์ตอน',
    title_mission: 'กิจกรรมเช็กอินเพื่อรับแพลงก์ตอน',
    detail: 'รายละเอียดและเงื่อนไข',
    checked: 'คุณเช็กอินไปแล้ว {0} วัน',
    date: 'วันที่ ',
    btn_title_checkin: 'เช็กอินวันนี้',
    btn_msg_checkin: 'กดเช็กอินเลย',
    title_success: 'เย่!',
    msg_success: 'คุณเช็กอินครบแล้ว',
    mission: 'Mission',
    coming_soon: 'พบกันเร็วๆ นี้',

    title_mission_list: 'ภารกิจ',
    play: 'เล่นเกม',
    play_game: 'เล่นเกม',
    play_success: 'เล่นแล้ว',
    game_match_error: 'ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง',
    survey: 'ตอบคำถาม',
    survey_success: 'เล่นแล้ว',
    detail_condition: 'รายละเอียดและเงื่อนไข',
    btn_play: 'เล่นเกม !',
    start_game: 'เริ่มเกม',
    match_tc_title: 'เกมจับคู่ มหาสมุทร',
    btn_survey: 'เล่นเกม !',
    detail_coming_soon: 'พบกันเร็ว ๆ นี้',

    game_confirm: {
        title: 'วิธีเล่น',
        msg: 'พาน้องจุดว่ายหลบสิ่งกีดขวางให้ได้นะ',
        btn: 'ตกลง',
    },
    game_puzzle_confirm: {
        title: 'วิธีเล่น',
        msg: 'ผจญภัยสุดหรรษา เรียงสัตว์น้ำเหมือนกัน 3 ตัว ให้ถึง {0} คะแนนนะ',
        btn: 'เล่นเกม',
        close: 'ปิด'
    },
    play_win: 'คุณเล่นเกมส์ชนะแล้ว',
    scroll_down: 'เลื่อนลงด้านล่าง',

    mission_transaction: 'ภารกิจทำธุรกรรม',
    mission_other: 'ภารกิจอื่นๆ',
    mission_comingsoon: 'พบกันเร็ว ๆ นี้',

    transaction_detail: 'รายละเอียด',
    transaction_condition: 'เงื่อนไข',
    btn_transaction_confirm: 'เข้าร่วม',
    btn_join: 'เข้าร่วม',
    month: 'เดือนที่',
    make_success: 'ทำสำเร็จ : ',
    timeCountDown: 'เหลือเวลาอีก ',
    day: 'วัน',
    max_qty: 'ผู้เล่นครบตามจำนวนแล้ว'
};
